const BankStatements = () => {
  return <p>Placeholder for bank statement upload</p>;
};

export default BankStatements;
